import { render, staticRenderFns } from "./scroll-text.vue?vue&type=template&id=18dc61d6&scoped=true&"
import script from "./scroll-text.vue?vue&type=script&lang=js&"
export * from "./scroll-text.vue?vue&type=script&lang=js&"
import style0 from "./scroll-text.vue?vue&type=style&index=0&id=18dc61d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc61d6",
  null
  
)

export default component.exports